<template>
    <div>
        <h2 class="headline-s form-headline-dealer-app">Basic Information </h2>

        <div class="field-type-dealer-app">
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <PrimeInputText 
                        :aria-required="true"
                        id="company_name" v-model="company_name"
                        :class="{
                            'invalid-state-input': errors.company_name != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="company_name" :class="{'invalid-state': errors.company_name}">
                        <p>Company Name *</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.company_name">{{ errors.company_name }}</p></div>
            </div>
            <div class="field-state-dealer-app">
                <custom-select
                    :aria-required="true"
                    v-model="selectedCountry"
                    label="Country *"
                    name="country" 
                    id="country" 
                    aria-label="Enter Country"
                    :error="errors.country != null"
                    :options="formattedCountries"
                />
                <div class="field-state input-folder"><p class="input-support-text invalid-state" v-if="errors.country">{{ errors.country }}</p></div>
            </div>
            <div class="input-row-dealer-app">
                <div class="field-state-dealer-app">
                    <custom-select
                        :aria-required="true"
                        id="dealer_type"
                        v-model="selectedDealerType"
                        label="Primary Resale Type *"
                        name="dealer_type" 
                        aria-label="Enter Primary Resale Type"
                        :options="formattedPrimaryResaleTypes"
                        :error="errors.dealer_type != null"
                    />
                    <div class="field-state input-folder"><p class="input-support-text invalid-state" v-if="errors.dealer_type">{{ errors.dealer_type }}</p></div>
                </div>
                <div class="field-state-dealer-app">
                    <custom-select
                        :aria-required="true"
                        id="customer_resales_types "
                        v-model:selected-options="selectedOtherDealerTypes"
                        label="Other Resale Types"
                        name="customer_resales_types " 
                        aria-label="Enter Other Resale Types"
                        :options="formattedResaleTypes"
                        multiple
                    />
                </div>
            </div>
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <PrimeInputText 
                        :aria-required="true"
                        id="federal_tax_id_or_state_license" v-model="federal_tax_id_or_state_license"
                        :class="{
                            'invalid-state-input': errors.federal_tax_id_or_state_license != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="federal_tax_id_or_state_license" :class="{'invalid-state': errors.federal_tax_id_or_state_license}">
                        <p>Federal Tax ID # *</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.federal_tax_id_or_state_license">{{ errors.federal_tax_id_or_state_license }}</p></div>
            </div>
            <div class="field-state-dealer-app input-folder" v-if="dealer_type == 'promotional'">
                <div class="input-folder--input">
                    <PrimeInputText 
                        id="asi" v-model="asi"
                        :class="{
                            'invalid-state-input': errors.asi != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="asi" :class="{'invalid-state': errors.asi}">
                        <p id="asi_label">ASI #</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.asi">{{ errors.asi }}</p></div>
            </div>
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <PrimeInputText 
                        id="in_care_of" v-model="in_care_of"
                        :class="{
                            'invalid-state-input': errors.in_care_of != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="in_care_of" :class="{'invalid-state': errors.in_care_of}">
                        <p>In Care Of</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.in_care_of">{{ errors.in_care_of }}</p></div>
            </div>
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <PrimeInputText 
                        :aria-required="true"
                        id="mailing_address_1" v-model="mailing_address_1"
                        :class="{
                            'invalid-state-input': errors.mailing_address_1 != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="mailing_address_1" :class="{'invalid-state': errors.mailing_address_1}">
                        <p>Mailing Address 1 *</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.mailing_address_1">{{ errors.mailing_address_1 }}</p></div>
            </div>
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <PrimeInputText 
                        id="mailing_address_2" v-model="mailing_address_2"
                        :class="{
                            'invalid-state-input': errors.mailing_address_2 != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="mailing_address_2" :class="{'invalid-state': errors.mailing_address_2}">
                        <p>Mailing Address 2</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.mailing_address_2">{{ errors.mailing_address_2 }}</p></div>
            </div>
            <div class="field-state-dealer-app input-folder">
                <div class="input-folder--input">
                    <PrimeInputText 
                        :aria-required="requireStateCity"
                        id="city" v-model="city"
                        :class="{
                            'invalid-state-input': errors.city != null
                        }"
                        placeholder=" "
                        fluid
                    />
                    <label for="city" :class="{'invalid-state': errors.city}">
                        <p>City {{ requireStateCity ? '*' : '' }}</p>
                    </label>
                </div>
                <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.city">{{ errors.city }}</p></div>
            </div>
            <div class="input-row-dealer-app">
                <div class="field-state-dealer-app input-folder" v-if="!['US', 'CA', 'PR'].includes(country)">
                    <div class="input-folder--input">
                        <PrimeInputText 
                            :aria-required="requireStateCity"
                            id="state_province" v-model="state_province"
                            :class="{
                                'invalid-state-input': errors.state_province != null
                            }"
                            placeholder=" "
                            fluid
                        />
                        <label for="state_province" :class="{'invalid-state': errors.state_province}">
                            <p>State/Province {{ requireStateCity ? '*' : '' }}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.state_province">{{ errors.state_province}}</p></div>
                </div>
                <div class="field-state-dealer-app" v-else>
                    <custom-select
                        :aria-required="requireStateCity"
                        v-model="selectedState"
                        :label="`State/Province ${ requireStateCity ? '*' : ''}`"
                        name="state_province" 
                        id="state_province" 
                        aria-label="Enter State/Province"
                        :options="formattedStates"
                        :error="errors.state_province != null"
                    />
                    <div class="field-state input-folder"><p class="input-support-text invalid-state" v-if="errors.state_province">{{ errors.state_province }}</p></div>
                </div>
                <div class="field-state-dealer-app input-folder">
                    <div class="input-folder--input">
                        <PrimeInputText 
                            :aria-required="requireStateCity"
                            id="zip_postal_code" v-model="zip_postal_code"
                            :class="{
                                'invalid-state-input': errors.zip_postal_code != null
                            }"
                            placeholder=" "
                            fluid
                        />
                        <label for="zip_postal_code" :class="{'invalid-state': errors.zip_postal_code}">
                            <p>Zip/Postal Code {{ requireStateCity ? '*' : '' }}</p>
                        </label>
                    </div>
                    <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.zip_postal_code">{{ errors.zip_postal_code}}</p></div>
                </div>
            </div>
            <div class="field-state-dealer-app">
                <custom-select
                    :aria-required="true"
                    v-model="selectedLocationtype"
                    label="Location Type *"
                    name="location_type" 
                    id="location_type" 
                    aria-label="Enter Location Type"
                    :options="formattedLocationTypes"
                    :error="errors.location_type != null"
                />
                <div class="field-state input-folder"><p class="input-support-text invalid-state" v-if="errors.location_type">{{ errors.location_type }}</p></div>
            </div>
        </div>
        <AddressValidationMessage
            class="field-state-dealer-app"
            :street1="mailing_address_1"
            :street2="mailing_address_2"
            :city="city"
            :state="state_province"
            :postal_code="zip_postal_code"
            :country="country"
            @useSuggestedAddress="useSuggestedShippingAddress"
        />
        <div class="field-state-dealer-app">
            <div class="textarea-folder">
                <textarea :aria-required="true" id="text-area" v-model="customer_business_description" required placeholder=" " :class="{'input-folder--input': true, 'invalid-state-input': errors.customer_business_description != null}"></textarea>
                <label class="paragraph-default" for="text-area">Please take a brief moment to describe your business *</label>
            </div>
            <div class="input-folder"><p class="input-support-text invalid-state" v-if="errors.customer_business_description">{{ errors.customer_business_description }}</p></div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    import { computed, watch, ref } from "vue";
    import AddressValidationMessage from "@/components/AddressValidationMessage.vue";
    let company_name = defineModel("company_name", {type: String, default: ''});
    let country = defineModel("country", {type: String, default: ''});
    let dealer_type = defineModel("dealer_type", {type: String, default: ''});
    let customer_resales_types = defineModel("customer_resales_types", {type: Array<String>, default: []});
    let federal_tax_id_or_state_license = defineModel("federal_tax_id_or_state_license", {type: String, default: ''});
    let asi = defineModel("asi", {type: String, default: ''});
    let in_care_of = defineModel("in_care_of", {type: String, default: ''});
    let mailing_address_1 = defineModel("mailing_address_1", {type: String, default: ''});
    let mailing_address_2 = defineModel("mailing_address_2", {type: String, default: ''});
    let city = defineModel("city", {type: String, default: ''});
    let state_province = defineModel("state_province", {type: String, default: ''});
    let zip_postal_code = defineModel("zip_postal_code", {type: String, default: ''});
    let location_type = defineModel("location_type", {type: String, default: ''});
    let customer_business_description = defineModel("customer_business_description", {type: String, default: ''});
    let errors = defineModel("errors", {
        type: Object,
        default(){
            return {};
        }
    });
    let props = defineProps({
        countries: {
            type: Object,
            default(){
                return {};
            }
        },
        states: {
            type: String,
            default: ""
        },
        resaleTypes: {
            type: Array<Object>,
            default: []
        },
        primaryResaleTypes: {
            type: Array<Object>,
            default: []
        },
    })
    let location_types = [
        {code: "customer_retail", name: "Retail"},
        {code: "customer_office", name: "Office"},
        {code: "customer_warehouse", name: "Warehouse"},
        {code: "customer_3rd_party", name: "3rd Party Logistics"},
        {code: "customer_po_box", name: "PO Box"}
    ];
    let availableStates = computed(()=>{
        return JSON.parse(props.states)[country.value];
    });
    let formattedStates = computed(()=>{
        return Object.entries(availableStates.value)?.map(([key, value]) => {
            return {
                key: key,
                value: value
            }
        });
    });
    let selectedState = computed({
        get(){
            return formattedStates.value.find(currentState => currentState.key == state_province.value) ?? {key: '', value: ''};
        },
        set(value){
            state_province.value = value.key;
        }
    });
    let formattedCountries = computed(() => {
        return Object.entries(props.countries).map(([key, value]) => {
            return {
                key: key,
                value: value
            };
        });
    });
    let selectedCountry = computed({
        get(){
            return formattedCountries.value.find(currentCountry => currentCountry.key == country.value) ?? {key: '', value: ''};
        },
        set(value){
            country.value = value.key;
        }
    })

    let formattedPrimaryResaleTypes = computed(() => {
        return props.primaryResaleTypes.map((resaleType) => {
            return {
                key: resaleType.code,
                value: resaleType.name
            };
        });
    });

    let selectedDealerType = computed({
        get(){
            return formattedPrimaryResaleTypes.value.find(currentDealerType => currentDealerType.key == dealer_type.value) ?? {key: '', value: ''};
        },
        set(value){
            dealer_type.value = value.key;
        }
    })
    let formattedLocationTypes = computed(()=>{
        return location_types.map(type=>{
            return {
                key: type.code,
                value: type.name
            }
        })
    });
    let selectedLocationtype = computed({
        get(){
            return formattedLocationTypes.value.find(currentLocationType => currentLocationType.key == location_type.value) ?? {key: '', value: ''};
        },
        set(value){
            location_type.value = value.key;
        }
    });

    const requireStateCity = computed(()=>{
        return !!country.value && ['US','CA'].includes(country.value);
    })

    let formattedResaleTypes = computed(() => {
        return props.resaleTypes.map((resaleType) => {
            return {
                key: resaleType.code,
                value: resaleType.name
            };
        });
    });

    let selectedOtherDealerTypes = ref([]);

    watch(() => selectedOtherDealerTypes.value, (newVal) => {
        customer_resales_types.value = newVal.map(v=>v?.key ?? '');
    }, {
        deep: true
    });

    watch(country, (newCountryValue, oldCountryValue) => {
        if (!['US', 'CA', 'PR'].includes(newCountryValue) && ['US', 'CA', 'PR'].includes(oldCountryValue)) {
            state_province.value = '';
            return;
        }
        if (['US', 'CA', 'PR'].includes(newCountryValue)) {
            let state = state_province.value.toLowerCase();
            let availableStateKeys = Object.keys(availableStates.value || {});

            let matchedState = availableStateKeys.find(
                key => availableStates.value[key].toLowerCase() === state || key.toLowerCase() === state
            );
            state_province.value = matchedState ?? '';
        }
    });

    let useSuggestedShippingAddress = (suggestedAddress) => {
        mailing_address_1.value = suggestedAddress.street1;
        mailing_address_2.value = suggestedAddress.street2;
        city.value = suggestedAddress.city;
        state_province.value = suggestedAddress.state;
        zip_postal_code.value = suggestedAddress.postal_code;
        country.value = suggestedAddress.country == 'USA' ? 'US' : suggestedAddress.country;
    };
</script>